import { Injectable } from '@angular/core';
import { MasterConstants } from '../constants/master-constants';

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

/**
 * @description Logger service for environment logging.
 */
@Injectable({
  providedIn: 'root'
})
export class LolLoggerService {
  private static level: LogLevel = LogLevel.DEBUG;

  public static debug(...message: any): void {
    LolLoggerService.writeToLog(LogLevel.DEBUG, ...message);
  }

  public static info(...message: any) {
    LolLoggerService.writeToLog(LogLevel.INFO, ...message);
  }

  public static warn(...message: any) {
    LolLoggerService.writeToLog(LogLevel.WARN, ...message);
  }

  public static error(...message: any) {
    LolLoggerService.writeToLog(LogLevel.ERROR, ...message);
  }

  public static toConsole(message: any) {
    var isDisplay = localStorage[MasterConstants.CONSOLE_MESSAGE];
    if (isDisplay == 1) {
      console.log(LolLoggerService.getLogDate(),message);
    }
  }

  /**
   * Write logs.
   */
  private static writeToLog(level: LogLevel, ...message: any) {
    if (level <= LogLevel.INFO) {
      // eslint-disable-next-line no-console
      console.log(LolLoggerService.getLogDate(), ...message);
    } else if (level === LogLevel.ERROR) {
      // eslint-disable-next-line no-console
      console.error(LolLoggerService.getLogDate(), ...message);
    } else if (level === LogLevel.WARN) {
      // eslint-disable-next-line no-console
      console.warn(LolLoggerService.getLogDate(), ...message);
    }
  }

  /**
   * To add the date on logs.
   */
  private static getLogDate(): string {
    const date = new Date();
    return '[' +
      date.getUTCFullYear() + '/' +
      (date.getUTCMonth() + 1) + '/' +
      date.getUTCDate() + ' ' +
      date.getUTCHours() + ':' +
      date.getUTCMinutes() + ':' +
      date.getUTCSeconds() + '.' +
      date.getMilliseconds() + ']';
  }
}
